/**
 * ThOrdenavel — cabeçalho de coluna clicável (canônico).
 *
 * A metade visual do motor de ordenação; o hook `useOrdenacao` e o
 * `ordenarLista` vivem em `@/lib/ordenacao` (um arquivo de componente só pode
 * exportar componentes — react-refresh). Toda tabela que quiser ordenar usa
 * ESTE trio, nunca um sort próprio:
 *
 *   const ordem = useOrdenacao<'nome' | 'endereco'>('nome');
 *   <ThOrdenavel chave="nome" ordem={ordem}>Equipamento</ThOrdenavel>
 *   const linhas = ordenarLista(itens, VALOR_POR_CHAVE[ordem.chave], ordem.sentido);
 */
import type { ReactNode } from 'react';
import { ChevronDown, ChevronUp, ChevronsUpDown } from 'lucide-react';
import type { Ordenacao } from '@/lib/ordenacao';
import { TableHead } from './Table';

export function ThOrdenavel<K extends string>({
  chave,
  ordem,
  children,
  className,
}: {
  chave: K;
  ordem: Ordenacao<K>;
  children: ReactNode;
  className?: string;
}) {
  const ativa = ordem.chave === chave;
  const Seta = !ativa ? ChevronsUpDown : ordem.sentido === 'asc' ? ChevronUp : ChevronDown;
  return (
    <TableHead
      className={className}
      aria-sort={ativa ? (ordem.sentido === 'asc' ? 'ascending' : 'descending') : undefined}
    >
      <button
        type="button"
        onClick={() => ordem.alternar(chave)}
        className="inline-flex items-center gap-1 uppercase tracking-wider hover:text-ink-1 dark:hover:text-ink-dark-1 transition-colors"
        data-testid={`ordenar-${chave}`}
      >
        {children}
        <Seta className={`h-3.5 w-3.5 shrink-0 ${ativa ? '' : 'opacity-40'}`} aria-hidden />
      </button>
    </TableHead>
  );
}
